module.exports = __webpack_public_path__ + "static/img/sleep.941c4216.png";